import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useRechte } from '../hooks/useRechte';
import { hatRecht } from '../lib/rechte';
import { InternetStatus, SchalterKey, schalterZustand } from '../lib/internetStatus';
import './InternetLeiste.css';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

const FELD: Record<SchalterKey, 'websuche_erlaubt' | 'github_tickets_erlaubt'> = {
  websuche: 'websuche_erlaubt',
  github: 'github_tickets_erlaubt',
};

const LABEL: Record<SchalterKey, string> = {
  websuche: 'Websuche',
  github: 'GitHub-Tickets',
};

interface Props {
  istAdmin: boolean;
}

/** Schmale Leiste unter dem Chat: Master-Schalter für Websuche und GitHub-Tickets. */
const InternetLeiste: React.FC<Props> = ({ istAdmin }) => {
  const [status, setStatus] = useState<InternetStatus | null>(null);
  const [geladen, setGeladen] = useState(false);
  const [fehler, setFehler] = useState(false);
  const { rechte } = useRechte();

  useEffect(() => {
    let mounted = true;
    axios
      .get<InternetStatus>(`${API_URL}/api/mandant/internet`)
      .then((r) => { if (mounted) { setStatus(r.data); setFehler(false); } })
      .catch(() => { if (mounted) setFehler(true); })
      .finally(() => { if (mounted) setGeladen(true); });
    return () => { mounted = false; };
  }, []);

  if (!geladen) return null;

  if (!status) {
    // GET ist für alle angemeldeten Benutzer offen; bei einem Fehler zeigt nur der Admin
    // die Meldung, Nicht-Admins sehen nichts.
    if (!fehler || !istAdmin) return null;
    return (
      <div className="k-internet">
        <span className="k-internet__hint">Status nicht verfügbar</span>
      </div>
    );
  }

  const umschalten = async (key: SchalterKey, wert: boolean) => {
    const vorher = status;
    setStatus({ ...status, [FELD[key]]: wert });
    try {
      const r = await axios.put<InternetStatus>(`${API_URL}/api/mandant/internet`, { [FELD[key]]: wert });
      setStatus(r.data);
    } catch {
      setStatus(vorher);
      alert('Einstellung konnte nicht gespeichert werden.');
    }
  };

  if (!istAdmin) {
    const w = schalterZustand(status, 'websuche', false, hatRecht(rechte, 'faehigkeit.websuche'));
    const g = schalterZustand(status, 'github', false, hatRecht(rechte, 'faehigkeit.github_tickets'));
    return (
      <div className="k-internet">
        <span>Websuche: {w.hinweis} · GitHub-Tickets: {g.hinweis}</span>
      </div>
    );
  }

  return (
    <div className="k-internet">
      {(['websuche', 'github'] as SchalterKey[]).map((key) => {
        const z = schalterZustand(status, key, true);
        return (
          <label key={key} className={'k-internet__opt' + (z.disabled ? ' is-disabled' : '')}>
            <input
              type="checkbox"
              checked={z.checked}
              disabled={z.disabled}
              onChange={(e) => umschalten(key, e.target.checked)}
            />
            <span>{LABEL[key]}{z.hinweis ? ` (${z.hinweis})` : ''}</span>
          </label>
        );
      })}
      <span className="k-internet__hint">Freigabe für weitere Benutzer unter Einstellungen → Rechte</span>
    </div>
  );
};

export default InternetLeiste;
